export default "__VITE_ASSET__d63d79e7__"